import { render, staticRenderFns } from "./CkditorCore.vue?vue&type=template&id=4fc0e0fe&"
import script from "./CkditorCore.vue?vue&type=script&lang=js&"
export * from "./CkditorCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports